import axios from 'axios';
import config from './config';

// Environment-based URL configuration
const getBaseURL = () => {
  const envUrl = process.env.VUE_APP_URL_HTTPDSP;
  const fallbackUrl = 'https://www.alareeef.com/DSPAPIs/APIs/';
  
  // Always prioritize environment variable if set
  if (envUrl && envUrl !== 'undefined') {
    return envUrl;
  }
  
  // Only use proxy in development if no env URL is set
  if (process.env.NODE_ENV === 'development') {
    return '/dsp-api/';
  }
  
  return fallbackUrl;
};

// Create axios instance with enhanced configuration
export const HTTPDSP = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000, // 30 seconds timeout
  withCredentials: false, // Prevent CORS cookie issues
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

// Request interceptor for adding authentication and logging
HTTPDSP.interceptors.request.use(
  (requestConfig) => {
    // Add authorization header if available
    if (config.authHeader) {
      requestConfig.headers.Authorization = config.authHeader;
    }
    
    return requestConfig;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Enhanced response interceptor with better error handling
HTTPDSP.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle different types of errors
    if (axios.isCancel(error)) {
      error.isAbort = true;
      return Promise.resolve({ data: null, canceled: true });
    }
    
    if (error.code === 'ERR_NETWORK') {
      error.isNetworkError = true;
    } else if (error.code === 'ECONNABORTED') {
      error.isTimeoutError = true;
    } else if (error.response) {
      const { status } = error.response;
      
      // Handle specific DSP status codes
      switch (status) {
        case 401:
          error.isAuthError = true;
          break;
        case 403:
          error.isForbiddenError = true;
          break;
        case 404:
          error.isNotFoundError = true;
          break;
        case 500:
          error.isServerError = true;
          break;
      }
    }
    
    return Promise.reject(error);
  }
);

// Helper functions for DSP operations
export const dspHelpers = {
  /**
   * Check login status
   * @param {string} msisdn - Mobile number
   */
  async checkLogin(msisdn) {
    const response = await HTTPDSP.get(`DSPCheckLogin.php?msisdn=${encodeURIComponent(msisdn)}`);
    return response.data;
  },

  /**
   * Subscribe user
   * @param {string} msisdn - Mobile number
   */
  async subscribe(msisdn) {
    const response = await HTTPDSP.get(`DSPSubscribe.php?msisdn=${encodeURIComponent(msisdn)}`);
    return response.data;
  },

  /**
   * Unsubscribe user
   * @param {string} msisdn - Mobile number
   */
  async unsubscribe(msisdn) {
    const response = await HTTPDSP.get(`DSPUnsubscribe.php?msisdn=${encodeURIComponent(msisdn)}`);
    return response.data;
  }
};

export default HTTPDSP;
